/**
 * Commerce7 Product Details
 */

import { renderVivinoScore } from "./c7-util";

export default function C7Collection() {
    const selectors = {};

    this.init = () => {
        c7.addAction("c7_products_detail_rendered", (content) => {
            // Do something after product detail rendered.
            jQuery(".c7-product__image ul").addClass("owl-carousel owl-theme");
            jQuery(".c7-product__image ul.owl-carousel").owlCarousel({
                loop: true,
                nav: false,
                dots: true,
                items: 1,
            });

            const headerEl = document.querySelector(".product-cart-sticky");
            const sentinalEl = document.querySelector(".sticky-show");

            if (headerEl && sentinalEl) {
                jQuery(window).scroll(function () {
                    if (jQuery(this).scrollTop() >= jQuery(".sticky-show").offset().top) {
                        headerEl.classList.add("enabled");
                    } else {
                        headerEl.classList.remove("enabled");
                    }
                });
            }

            moveProductTitle();

            jQuery(window).on("resize", () => moveProductTitle());
            getBundleItems();

            removePriceDot();

            renderPromo();
            const video = handleVideoUrl();
            renderVideo(video);
            nextSlider();
        });

        c7.addAction("c7_products_gift_card_rendered", (content) => {
            // Gift card popup
            jQuery(".c7-product__add-to-cart__price").after(
                jQuery(".gift-card-model")
            );
            jQuery(".model-body").append(
                jQuery(".c7-product__add-to-cart__giftcard")
            );
            jQuery(".model-body").append(
                '<button type="button" class="c7-btn c7-btn--primary checkrequire-add-to-card">add to cart</button>'
            );
            jQuery(".model-body").append(jQuery(".c7-product__add-to-cart__form"));
            jQuery(".show-popup-gift-card").click(() => {
                jQuery(".gift-card-model").toggleClass("open");
            });

            jQuery(".gift-card-model .close").click(function () {
                jQuery(this).closest(".gift-card-model").removeClass("open");
            });

            jQuery("#c7-giftMessage-group").removeClass("c7--hidden");
            jQuery(".c7-product__add-to-cart__giftcard button").addClass("c7--hidden");
            jQuery('textarea[name="giftMessage"]').before(jQuery(".text-note"));
            jQuery('.gift-card-model textarea[name="giftMessage"]').attr("placeholder", "Your message is required");
            /* Close after add to card */
            jQuery(".gift-card-model .checkrequire-add-to-card").click(
                () => {
                    jQuery(".your-message-is-required").remove();
                    if (
                        jQuery('.gift-card-model input[name="email"]').val() != "" &&
                        jQuery('.gift-card-model textarea[name="giftMessage"]').val() != ""
                    ) {
                        jQuery(".gift-card-model .c7-product__add-to-cart__form button").click();
                        jQuery(".gift-card-model .close").click();
                    } else {
                        if (jQuery('.gift-card-model textarea[name="giftMessage"]').val() == "") {
                            jQuery('.gift-card-model textarea[name="giftMessage"]').after('<p class="c7-form__error your-message-is-required" role="alert">Your message is required</p>');
                        } else {
                            jQuery(".gift-card-model .c7-product__add-to-cart__form button").click();
                        }
                    }
                }
            );
        });
    };
    const getBundleItems = () => {
        const isBundle = jQuery(".c7-product-Bundle");
        if (isBundle.length == 0 || !isBundle) {
            return;
        }
        let slugArr = location.pathname.split("/").slice(1);
        if (slugArr.length) {
            let slug = slugArr[1];
            jQuery.ajax({
                type: "GET",
                dataType: "json",
                url: theme_object.ajax_url,
                data: {
                    action: "get_bundle_items",
                    slug: slug,
                },
                context: this,
                beforeSend: function () { },
                success: function (response) {
                    if (response.success) {
                        const titleProduct = jQuery(
                            ".product-cart-sticky .product-title"
                        ).text();
                        jQuery(".bundle-list-line").html(response.content.bundle_line);
                        jQuery(".bundle-list-cards-wrapper").append(
                            `<h2 class="title-section">A look into <i>‘${titleProduct}’</i></h2>`
                        );
                        jQuery(".bundle-list-cards-wrapper").append(
                            response.content.bundle_card
                        );
                        response.content.bundle_items.forEach((item) => {
                            jQuery(".product-detail .product-details .bundle-item").append(
                                `<h5>${item.productTitle}</h5>`
                            );
                        });
                        c7.doAction("c7_product_bundle_collections_rendered");
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    console.log(
                        "The following error occured: " + textStatus,
                        errorThrown
                    );
                },
            });
        }
    };
    const moveProductTitle = () => {
        if (jQuery(window).outerWidth() <= 1023) {
            jQuery(".product-detail").prepend(
                jQuery(".c7-product__title.product-title")
            );
        } else {
            jQuery(".product-details").prepend(
                jQuery(".c7-product__title.product-title")
            );
        }
    };

    /* Handle video url */
    const handleVideoUrl = () => {
        const videoUrl = jQuery("#get-product-video").val();
        if (!videoUrl) {
            return {
                videoUrl,
            };
        }
        let type = "other";
        if (
            -1 !== videoUrl.indexOf("youtube") ||
            -1 !== videoUrl.indexOf("youtu.be")
        ) {
            type = "youtube";
            const regex =
                /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/gm;
            const segments = [...videoUrl.matchAll(regex)];
            const videoID = segments[0][7];
            const thumbnail = "https://i3.ytimg.com/vi/" + videoID + "/hqdefault.jpg";
            return {
                videoUrl,
                type,
                videoID,
            };
        }

        if (-1 !== videoUrl.indexOf("vimeo")) {
            type = "vimeo";
            const regex =
                /(?:https?:\/\/)?(?:www.)?(?:player.)?vimeo.com\/(?:[a-z]*)*([0-9]{6,11})[?]?.*/gm;
            const segments = [...videoUrl.matchAll(regex)];
            const videoID = segments[0][1];
            return {
                videoUrl,
                type,
                videoID,
            };
        }
        return {
            videoUrl,
            type,
        };
    };

    const renderVideo = (video) => {
        let html = "";
        if (video.videoUrl) {
            html += '<div class="video-container">';
            if ("youtube" === video.type) {
                html +=
                    '<iframe class="background-video" src="https://www.youtube.com/embed/?' +
                    video.videoID +
                    "&modestbranding=1&autohide=1&controls=1&rel=0&loop=1&enablejsapi=1&disablekb=1&playlist=" +
                    video.videoID +
                    '&autoplay=0&mute=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>';
            } else if ("vimeo" === video.type) {
                html +=
                    '<iframe class="background-video" src="https://player.vimeo.com/video/' +
                    video.videoID +
                    '?loop=1&controls=1&autoplay=0&muted=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>';
            } else {
                html +=
                    '<iframe class="background-video" src="' +
                    video.videoUrl +
                    '&modestbranding=1&autohide=1&controls=0&rel=0&loop=1&autoplay=1&muted=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>';
            }
            html += "</div>";
        }
        if (jQuery(".product-video")) {
            jQuery(".product-video").append(html);
        }
    };

    const renderPromo = () => {
        if ("null" === shop_promo || "undefined" === typeof shop_promo) {
            return;
        }

        const promoCode = jQuery("#get-data-shop-promo").val();
        let listPromoCode = [];
        const data = JSON.parse(shop_promo);
        let html = '<div class="shop-promo-detail">';
        if (jQuery(".c7-error-page").length == 0 || !jQuery(".c7-error-page")) {
            var productType = document
                .querySelector(".c7-product-detail")
                .getAttribute("data-product-type");
        }
        if (data.length == 0) {
            return;
        }
        if ("Wine" === productType) {
            data.forEach(function (item, index) {
                if (index <= 1 && item.code) {
                    listPromoCode.push(item.code)
                }
            })
        } else if ("Bundle" === productType) {
            data.forEach(function (item, index) {
                if (index <= 0 && item.code) {
                    listPromoCode.push(item.code)
                }
            })
        }
        if (jQuery("#get-data-shop-promo").val() != 'null') {
            listPromoCode = promoCode
                .trim()
                .toLowerCase()
                .replace(" ", "-")
                .split("\n");
        }
        if (listPromoCode)
            for (let i = 0; i < data.length; i++) {
                const element = data[i];
                if (listPromoCode.indexOf(element.code) === -1) {
                    continue;
                }
                html += '<div class="c7-promo-block">';
                html += '<div class="c7-promo-icon">';
                html += '<img src="' + element.icon + '" alt="icon">';
                html += "</div>";
                html += '<div class="c7-promo-text">';
                html += atob(element.text);
                html += "</div>";
                html += "</div>";
            }

        html += "</div>";
        jQuery(".section-shop-promo-detail").append(html);
    };

    const removePriceDot = () => {
        jQuery(
            ".c7-product__add-to-cart__price span.c7-sr-only + span,.c7-product__add-to-cart__price .c7-price--discounted"
        ).each(function (i, e) {
            let text = jQuery(e).text();
            jQuery(e).text(
                text.replace(".00", "").replace("Was", "").replace("Now", "")
            );
        });
    };
    const nextSlider = () => {
        jQuery(".c7-product__image.product-image").click(function () {
            jQuery(".c7-product__image ul.owl-carousel").trigger("next.owl.carousel");
        });
    };
}
